import axios from '../shared/axios';
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function saveForecast(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Forecast/SaveForecast`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'CREATE':
                        events.onNotification_CREATED();
                        break;
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getForecast(forecastid) {
    return axios.get(`/api/Forecast/GetForecast?earlyforecastid=${forecastid}`);
}

export function getForecasts(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/Forecast/LoadForecastsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
}

export function deleteForecastDraft(forecastid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/Forecast/DeleteDraft?forecastid=${forecastid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function getLastForecastAmounts(contractId, projectorderids) {
    return axios.post(`/api/Forecast/GetLastForecastAmounts`, { contractId, projectorderids });
}

export function importForecasts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Forecast/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteForecastDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/Forecast/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateForecastDrafts(data) {
    console.log(data);
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Forecast/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}


export function getForecastsReducedV2(companyid, contractid, type, showDrafts, accessibleWfIds) {
    return axios.post(`/api/Forecast/RegisterListV2`, {
        showDrafts: showDrafts,
        showRelations: process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true',
        showTags: process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true',
        showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
        excludeTagHeaders: true,
        accessibleWfIds
    },
        { params: { companyid, contractid, type } });
}